import { ActionType } from '../../types/general';

export const DashboardActions = {
    autoRedirectBannerShown: () =>
        ({
            type: 'Dashboard/AutoRedirectBannerShown',
            payload: {},
        } as const),

    autoRedirectBannerDismissed: () =>
        ({
            type: 'Dashboard/AutoRedirectBannerDismissed',
            payload: {},
        } as const),

    trendCardDaysChanged: (days: number) =>
        ({
            type: 'Dashboard/TrendCardDaysChanged',
            payload: {
                days,
            },
        } as const),

        deviceTrendCardDaysChanged: (days: number) =>
        ({
            type: 'Dashboard/DeviceTrendCardDaysChanged',
            payload: {
                days,
            },
        } as const),


    trendListItemCheckboxClicked: (channelId: number, deviceId: string) =>
        ({
            type: 'Dashboard/TrendListItemCheckboxClicked',
            payload: {
                channelId,
                deviceId,
            },
        } as const),

    trendListItemCheckboxClear: () =>
        ({
            type: 'Dashboard/TrendListItemCheckboxClear',
        } as const),

    trendListItemEntered: (channelId: number, deviceId: string) =>
        ({
            type: 'Dashboard/TrendListItemEntered',
            payload: {
                channelId,
                deviceId,
            },
        } as const),

    trendListItemLeft: () =>
        ({
            type: 'Dashboard/TrendListItemLeft',
        } as const),

    inActiveLogOut: (inActiveLogOut: boolean) =>
        ({
            type: 'Dashboard/inActiveLogOut',
            payload: { inActiveLogOut },
        } as const),

    locationRefreshNeeded: (isRefresh: boolean) =>
        ({
            type: 'Dashboard/LocationRefresh',
            payload: { isRefresh },
        } as const),

    locationRefreshDone: (isRefresh: boolean) =>
        ({
            type: 'Dashboard/locationRefresh',
            payload: { isRefresh },
        } as const),
} as const;

export type DashboardActions = ActionType<typeof DashboardActions>;
